import { IFlightResultItem } from '@/containers/SearchFlightTab/SearchFlightResultItem/index.d';
import Head from 'next/head';
import React from 'react';
import { lunarYear } from '@/utils/seoHelper';
import { slugify } from '@/utils/stringConvert';
import { Typography } from '@mui/material';
import { getDate, getMonth } from 'date-fns';
import { getHostnameFromEnv } from '@/utils/getHostName';

interface TripDetailMetaHeaderProps {
  startPoint: IFlightResultItem | null;
  toPoint: IFlightResultItem | null;
  company: string;
  companySlug: string;
}

const TripDetailMetaHeader: React.FC<TripDetailMetaHeaderProps> = ({
  startPoint, toPoint, company, companySlug,
}) => {
  const from = startPoint?.location || '';
  const to = toPoint?.location || '';
  const hostName = typeof window !== 'undefined' ? window.location.hostname : getHostnameFromEnv(process.env.APP_ENV || '');

  const canonicalLink = `https://${hostName}/vn/ve-may-bay/${companySlug}-tu-${slugify(from)}-di-${slugify(to)}.${startPoint?.id}.${toPoint?.id}.vi`;
  return (
    <>
      <Head>
        <title>{`Đặt mua vé máy bay ${company} từ ${from} đi ${to} giá rẻ nhất, xem giá vé máy bay ${company} Tết ${lunarYear} đi ${to} | Goyolo.com`}</title>
        <meta
          name="description"
          content={`Săn vé máy bay ${company} giá cực rẻ từ ${from} đi ${to} với nhiều khuyến mãi. Đổi vé, hoàn huỷ vé dễ dàng. Tra cứu bảng giá, lịch bay giữa các hãng hàng không, xe khách, xe lửa trên cùng 1 màn hình để chọn được chuyến xe giá rẻ nhất và giờ di chuyển ngắn nhất. Đặt mua online vé máy bay đi ${to} giá rẻ nhất. Giá đã bao gồm thuế, phí. Đặt vé máy bay ${company} Tết ${lunarYear} từ ${from} đi  ${to} | Goyolo.com`}
        />
        <link
          rel="alternate"
          type="text/html"
          href={canonicalLink}
          hrefLang="x-default"
          title="Tiếng Việt"
        />
        <link
          rel="canonical"
          href={canonicalLink}
        />
      </Head>
      <Typography
        component="h1"
        fontSize="0"
        lineHeight="0"
      >
        {`Vé máy bay ${company} từ ${from} đi ${to} giá rẻ nhất ngày ${getDate(new Date())} tháng ${getMonth(new Date()) + 1} `}
      </Typography>
    </>
  );
};

export default TripDetailMetaHeader;
